import ErrorCodes from '@/core/misc/ErrorCodes';

/**
 * Класс для работы с ошибками JSON-RPC
 */
class RpcResponseError extends Error {

	/**
	 * Код ошибки
	 */
	code: number;

	/**
	 * Дополнительные данные об ошибке
	 */
	data: any;

	/**
	 * Severity ошибки с бэка ('error', 'warning', 'notice')
	 */
	severity: string | null;

	/**
	 * ID события в Sentry на бэке
	 */
	sentryId: string | null;

	/**
	 * Дополнительные данные для отладки
	 */
	debugData: any;

	constructor(message: string = '', code: number = 0, data: any = null) {
		super(message);
		this.name = 'RpcResponseError';
		this.code = code;
		this.data = data;
		this.severity = null;
		this.sentryId = null;
		this.debugData = null;
	}

	/**
	 * Создание экземпляра из данных сервера
	 */
	static fromServer(data: any): RpcResponseError {
		const error = new RpcResponseError(data.message, data.code, data.data);
		error.severity = data.severity ?? null;
		error.sentryId = data.sentryId ?? null;
		error.debugData = data.debugData ?? null;
		return error;
	}

	/**
	 * Создание экземпляра для транспортной ошибки (сеть, таймаут, HTTP 500)
	 */
	static fromTransportError(error: Error): RpcResponseError {
		return new RpcResponseError(error.message, 0, { originalError: error.name });
	}

	/**
	 * Создание экземпляра для таймаута запроса
	 */
	static fromTimeout(): RpcResponseError {
		return new RpcResponseError('Request timeout', ErrorCodes.TIMEOUT_ERROR, null);
	}
}

export default RpcResponseError;